import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const Root = () => {
  const isProtected = process.env.REACT_APP_PASSWORD_PROTECT === "true";
  const correctPassword = process.env.REACT_APP_BUILD_PASSWORD;
  
  const [authorized, setAuthorized] = useState(
    !isProtected || sessionStorage.getItem('tmd_auth') === 'true'
  );

  useEffect(() => {
    if (isProtected && !authorized) {
      const passwordInput = prompt("Enter build password:");
      if (passwordInput === correctPassword) {
        sessionStorage.setItem('tmd_auth', 'true');
        setAuthorized(true);
      } else if (passwordInput !== null) {
        alert("ah ah ah... you didnt say the magic word");
        window.location.reload();
      }
    }
  }, [isProtected, authorized, correctPassword]);

  if (isProtected && !authorized) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#000',
        color: '#fff',
        fontFamily: 'monospace',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1>ah ah ah...</h1>
        <p>you didnt say the magic word</p>
      </div>
    );
  }

  return <App afdQuery=""/>;
};

ReactDOM.render(
  <Root />,
  document.getElementById('root')
);
